export default __webpack_public_path__ + "static/media/headerBackground.ecc89ef3.png";